import type { GetImpactAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactAuditByIdArgs = {
  id: string;
};

export const useGetImpactAuditById = createQueryHook<
  UseGetImpactAuditByIdArgs,
  GetImpactAuditByIdResponseRow[],
  GetImpactAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impact.impactAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact_audit: data }),
  graphqlDocument: GetImpactAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
